import { useMemo } from "react";
import { trpc } from "../trpc";
import { ListChatbotsInput } from "@zapier/bff";

export function useQueryChatbots(parameters: ListChatbotsInput) {
  const { data, isLoading, isFetching } =
    trpc.chatbot.list.useQuery(parameters);

  const chatbots = useMemo(() => data?.data, [data]);
  const meta = useMemo(() => data?.meta, [data]);

  return {
    chatbots,
    isLoading,
    isFetching,
    meta,
  };
}

export type Chatbot = NonNullable<
  ReturnType<typeof useQueryChatbots>["chatbots"]
>[number];
